import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({ selector: '[antiAutoComplete]' })
export class AntiAutoCompleteDirective {
  @Input() antiAutoComplete: boolean;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    //this.createFalseInput();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //alert('Changes!');
    this.createFalseInput();
  }

  createFalseInput() {
    if (this.antiAutoComplete) {
      //this.el.nativeElement.style.backgroundColor = 'yellow';
      var falseInput = document.createElement('input');
      falseInput.setAttribute('type', 'password');
      falseInput.setAttribute('style', 'display:none;');
      this.el.nativeElement.insertBefore(falseInput, this.el.nativeElement.firstChild);

      var falseInput2 = document.createElement('input');
      falseInput2.setAttribute('type', 'email');
      falseInput2.setAttribute('style', 'display:none;');
      this.el.nativeElement.insertBefore(falseInput2, this.el.nativeElement.firstChild);

      //var id = this.el.nativeElement.id;
      //jQuery("#" + id).prepend('<input type="password" style="display:none"/>');
    } else {
      var passInputs = document.getElementsByName('password');
      jQuery(passInputs).removeAttr('autocomplete');

      var emailInputs = document.getElementsByName('email');
      jQuery(emailInputs).removeAttr('autocomplete');
    }
  }
}
